<template>
    <h2>Your Email Successfully Confirmed.</h2>
</template>